import { ChangeDetectorRef, Component, ViewChild } from '@angular/core';
import { DwComponent, DwComponentType, UserProfileComponent } from '@devwareapps/devware-cap';
import { switchMap } from 'rxjs/operators';
import { ProfileInlineEditService } from './services/profile-inline-edit.service';
import { Observable, of } from 'rxjs';
import { ActivatedRoute } from '@angular/router';

@DwComponent({ key: 'fitness-user-profile', name: 'My Streaker profile',
    componentType: DwComponentType.pageComponent, isGlobal: true })
@Component({
    selector: 'app-fitness-user-profile',
    template: `<app-central-profile-context *ngIf="!streakAgnostic" kind="streaker" name="My profile"></app-central-profile-context><main class="fitness-user-profile">
      <dw-user-profile *ngIf="showProfile" #profile></dw-user-profile>
    </main>`,
    styles: [`:host { display: block; } .fitness-user-profile { max-width: 1200px; margin: auto; padding: 1.5rem; }
      header { display: flex; justify-content: space-between; align-items: center; gap: 1rem; flex-wrap: wrap; margin-bottom: 1.5rem; }
      h1 { margin: .5rem 0 0; }`],
})
export class FitnessUserProfileComponent {
    showProfile = true;
    streakAgnostic: boolean;
    constructor(private changeDetector: ChangeDetectorRef, private inline: ProfileInlineEditService, route: ActivatedRoute) {
        this.streakAgnostic = route.snapshot.data.streakAgnostic === true;
    }
    @ViewChild('profile') profile: UserProfileComponent;
    allowChallengeChange = () => this.canNavigate();
    reloadProfile(): void {
        this.showProfile = false;
        this.changeDetector.detectChanges();
        this.showProfile = true;
    }
    canNavigate(): Observable<boolean> {
        return this.inline.canNavigate().pipe(switchMap(allowed => allowed && this.profile ? this.profile.canNavigate() : of(allowed)));
    }
}
